/******************************************************************************************
 *	License Delegation Detail Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.consumableUsageModal', [])
    .factory(
      'ConsumableUsageModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/consumable-usage-modal.html',
          controller: 'ConsumableUsageModalController',
          classNames: 'consumable-usage-modal'
        });
      }
    )
    .controller('ConsumableUsageModalController', consumableUsageModalController);
  /* @ngInject */
  function consumableUsageModalController(
    _,
    $log,
    $scope,
    ConsumableUsage,
    ConsumableUsageList,
    ConsumableUsageModal,
    CurtainNotifications,
    DemoMode,
    MiniJil,
    RcConsumableUsageList
  ) {
    $scope.fetchingUsages = false;

    $scope.showStartDate = false;

    if ($scope.fulfillableItem) {
      if ($scope.fulfillableItem.consumptionSummary.consumableUsageList) {
        // Make a copy of the product's usage list so we don't replace the usages shown in the main plans UI
        $scope.consumableUsageList = _.cloneDeep(
          $scope.fulfillableItem.consumptionSummary.consumableUsageList
        );
        // Set the page size for fetching usages
        $scope.consumableUsageList.pagination.pageSize = 10;
        // Set the total number of pages based on total count and page size
        $scope.consumableUsageList.pagination.totalPages = _.ceil(
          $scope.consumableUsageList.pagination.itemCount /
            $scope.consumableUsageList.pagination.pageSize
        );
        $scope.consumableUsageList.sortBy('expiration_date', false);
      }

      $scope.fetchUsage = function(options = {}) {
        if ($scope.consumableUsageList) {
          $scope.fetchingUsages = true;

          const onSuccess = () => {
            _.forEach($scope.consumableUsageList.items, usage => {
              usage.name = processName(usage);
              usage.showStartDate = checkValidConsumableUnit(usage);
            });
            $scope.fetchingUsages = false;
          };

          const onError = (error) => {
            CurtainNotifications.show(
              CurtainNotifications.ERROR,
              'consumableUsageModal.notifications.usageFetchError'
            );
            $log.error('Failed to fetch consumable usage', error);
            // Reset to the currentPage that was set prior to this failed call,
            // so the pagination shown is accurate for the list items shown
            if (_.isInteger(options.priorPage)) {
              $scope.consumableUsageList.pagination.currentPage = options.priorPage;
            }
            $scope.fetchingUsages = false;
          };

          if (DemoMode.isEnabled()) {
            MiniJil.getUsageList(
              _.invoke($scope.consumableUsageList, 'parentConsumable.getQueryParams'),
              $scope.consumableUsageList.pagination
            ).then(responseData => {
              $scope.consumableUsageList.items = _.map(responseData, item =>
                ConsumableUsage.apiResponseTransformer(item)
              );
              onSuccess();
            });
          } else {
            $scope.consumableUsageList
              .refresh()
              .then(onSuccess)
              .catch(onError);
          }
        }
      };

      $scope.getConsumableUnits = function(item) {
        return _.get(
          item,
          'fulfillableItem.units.default',
          _.get(item, 'fulfillableItem.chargingModel.unit')
        );
      };

      $scope.nextPage = function() {
        const currentPage = $scope.consumableUsageList.pagination.currentPage;
        $scope.consumableUsageList.pagination.currentPage = _.min([
          $scope.consumableUsageList.pagination.currentPage + 1,
          $scope.consumableUsageList.pagination.totalPages
        ]);
        $scope.fetchUsage({priorPage: currentPage});
      };

      $scope.prevPage = function() {
        const currentPage = $scope.consumableUsageList.pagination.currentPage;
        $scope.consumableUsageList.pagination.currentPage = _.max([
          $scope.consumableUsageList.pagination.currentPage - 1,
          1
        ]);
        $scope.fetchUsage({priorPage: currentPage});
      };

      $scope.removeModal = function() {
        //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
        ConsumableUsageModal.remove({cancelled: true});
      };

      if ($scope.fulfillableItem.hasMoreConsumables) {
        $scope.fetchUsage();
      } else if ($scope.consumableUsageList) {
        _.forEach($scope.consumableUsageList.items, usage => {
          usage.name = processName(usage);
          usage.showStartDate = checkValidConsumableUnit(usage);
        });
      }
    } else {
      if ($scope.product.consumables) {
        // Make a copy of the product's usage list so we don't replace the usages shown in the main plans UI
        $scope.consumableUsageList = new RcConsumableUsageList($scope.product.consumableUsageList);
        // Set the page size for fetching usages
        $scope.consumableUsageList.pagination.pageSize = 10;
        // Set the total number of pages based on total count and page size
        $scope.consumableUsageList.pagination.totalPages = _.ceil(
          $scope.consumableUsageList.pagination.itemCount /
            $scope.consumableUsageList.pagination.pageSize
        );
        $scope.consumableUsageList.sortBy('expiration_date', false);
      }

      $scope.fetchUsage = function(options = {}) {
        if ($scope.consumableUsageList) {
          $scope.fetchingUsages = true;

          $scope.consumableUsageList
            .refresh()
            .then(() => {
              _.forEach($scope.consumableUsageList.items, usage => {
                usage.name = $scope.product.getNameForUsage(usage);
                usage.showStartDate = checkValidConsumableUnit(usage);
              });
              $scope.fetchingUsages = false;
            })
            .catch((error) => {
              CurtainNotifications.show(
                CurtainNotifications.ERROR,
                'consumableUsageModal.notifications.usageFetchError'
              );
              $log.error('Failed to fetch consumable usage', error);
              // Reset to the currentPage that was set prior to this failed call,
              // so the pagination shown is accurate for the list items shown
              if (_.isInteger(options.priorPage)) {
                $scope.consumableUsageList.pagination.currentPage = options.priorPage;
              }
              $scope.fetchingUsages = false;
            });
        }
      };

      $scope.nextPage = function() {
        const currentPage = $scope.consumableUsageList.pagination.currentPage;
        $scope.consumableUsageList.pagination.currentPage = _.min([
          $scope.consumableUsageList.pagination.currentPage + 1,
          $scope.consumableUsageList.pagination.totalPages
        ]);
        $scope.fetchUsage({priorPage: currentPage});
      };

      $scope.prevPage = function() {
        const currentPage = $scope.consumableUsageList.pagination.currentPage;
        $scope.consumableUsageList.pagination.currentPage = _.max([
          $scope.consumableUsageList.pagination.currentPage - 1,
          1
        ]);
        $scope.fetchUsage({priorPage: currentPage});
      };

      $scope.removeModal = function() {
        //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
        ConsumableUsageModal.remove({cancelled: true});
      };

      if (_.get($scope, 'product.showMore')) {
        $scope.fetchUsage();
      } else if ($scope.consumableUsageList) {
        _.forEach($scope.consumableUsageList.items, usage => {
          usage.name = $scope.product.getNameForUsage(usage);
          usage.showStartDate = checkValidConsumableUnit(usage);
        });
      }
    }

    function processName(usage) {
      return (
        usage.name ||
        $scope.consumableItem.offerNames[usage.offerId] ||
        $scope.consumableItem.product.longName
      );
    }

    function checkValidConsumableUnit(usage) {
      var validConsumableUnits = ['transactions'];
      if(_.includes(validConsumableUnits, usage.unit)) {
        $scope.showStartDate = true;
        return true;
      } else {
        $scope.showStartDate = false;
        return false;
      }
    }
  }
})();
